import Vue from 'vue'
import store from './../../store'
import notificationService from './../notification'

// The account is cleared only after leaving the current page: mounted components
// read nested account fields (e.g. account.address.street) until they unmount.
const clearAccount = () => store.dispatch('account/store', {})

export default (loginParams) => {
  notificationService.disconnectSocket()
  // :TODO: Remove interval based notifications
  notificationService.disconnectNotifications()
  return store.dispatch('auth/logout')
    .then((response) => {
      // Aborted when already on Login; the account must be cleared either way
      Vue.router.push({
        name: 'Login',
        query: loginParams
      }, clearAccount, clearAccount)
      return response
    })
}



// WEBPACK FOOTER //
// ./src/services/auth/logout.js